import { api } from '@/api';

export type GeneralFeedbackExportResponse = Blob;

const generalFeedbackExportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getGeneralFeedbackExport: builder.query<GeneralFeedbackExportResponse, void>({
      query: () => ({
        url: `debug/general-feedback-export`,
        method: 'GET',
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
        responseHandler: async (response) => {
          return await response.blob();
        },
        cache: 'no-cache',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetGeneralFeedbackExportQuery } = generalFeedbackExportApi;
